export const  BANK_MAIL_DETAILS_API = {
    
    GET_ALL: `v1/api/bankDetails`,
    ADD: `v1/api/bankDetails`,
    UPDATE: `v1/api/bankDetails`,
    CHANGE_STATUS: `v1/api/bankDetails/changeStatus`,
    GET_BY_ID: `v1/api/bankDetails/getBankDetailsById`,
    GET_QUERY_FIELD: `v1/api/bankDetails/getQueryField`,
    GET_BANK_NAMES: `v1/api/bankDetails/getBankNames`,

    GET_BANK_OPTIONS_MAIL:`v1/api/bankDetails/getBankNames?stuCountryId=`, 
    GET_BANK_BY_NAME: `v1/api/bankDetails/getZonalOffices?bankName=`,
    GET_BANK_OTHER_DETAILS: `v1/api/bankDetails/getBankOtherDetails?bankName=`,
}; 